export function decoderThreadCount(width: number, height: number) {
  if (!crossOriginIsolated || typeof SharedArrayBuffer === "undefined") return 1;
  return width * height >= 1280 * 720 && navigator.hardwareConcurrency >= 4 ? 2 : 1;
}
